import(/* webpackMode: "eager" */ "/home/web/talenzap/apps/frontend/web/src/app/(public)/forgot-password/page.tsx");
